<div class="report-heading d-flex align-items-center justify-content-between pr-4 pl-4">

  <h2 class="detail-heading"> {{ chartTitle | translate }}
    <ng-container *ngIf="neigh_name">{{neighNname}} {{'reports.neighborhood'|translate}}</ng-container>
    <ng-container *ngIf="project_name">{{project_name}} {{'reports.projectName'|translate}}</ng-container>
    <span *ngIf="minDateOnwards">({{ minDateOnwards }})</span>
  </h2>
  <div class="d-flex align-items-center justify-content-between">
    <ng-container *ngIf="selected_neigh.length">
      <app-dropdown-checkbox-selection [search]="true" [dropDownOption]="NeighList" [selected_item]="selected_neigh"
        (dropDownValue)="trendsdropDownChange($event, 'neigh_name')" [showInvalueText]="false"  [json_data]="true">
      </app-dropdown-checkbox-selection>
    </ng-container>

    <ng-container *ngIf="GradesDropdown">
      <app-dropdown-radio-selection [dropDownOption]="GradesDropdown"
        (dropDownValue)="trendsdropDownChange($event, 'grade')" [showInvalueText]="false"
        [json_data]="true" [chartAnalysis]="true">
      </app-dropdown-radio-selection>
    </ng-container>

    <ng-container *ngIf="UnitTypes?.length">
      <app-dropdown-checkbox-selection [chooseOptions]="'reports.please_select_unit_types'" [dropDownOption]="UnitTypes"
        [selected_item]="selected_unit_type" (dropDownValue)="trendsdropDownChange($event,'unit_type')"
        [showInvalueText]="false" [json_data]="true" [unit]="true" >
      </app-dropdown-checkbox-selection>
    </ng-container>

      <ng-container *ngIf="warehouseDropdown">
      <app-dropdown-radio-selection [dropDownOption]="warehouseDropdown"
        (dropDownValue)="trendsdropDownChange($event, 'warehouse')" [showInvalueText]="false"
        [json_data]="true" [chartAnalysis]="true">
      </app-dropdown-radio-selection>
    </ng-container>

    <!-- <ng-container *ngIf="this.selected_unit_size">
      <app-dropdown-radio-selection [dropDownOption]="UnitSizeDropdown"
        (dropDownValue)="trendsdropDownChange($event, 'unit_size')" [showInvalueText]="false" [chartAnalysis]="true">
      </app-dropdown-radio-selection>
    </ng-container> -->


    <ng-container *ngIf="UnitSizeDropdown">
      <app-dropdown-checkbox-selection
        [search]="false"
        [chooseOptions]="'reports.pleaseSelectUnitSize'"
        [dropDownOption]="UnitSizeDropdown"
        [selected_item]="selected_unit_size"
        (dropDownValue)="trendsdropDownChange($event, 'unit_size')"
        [showInvalueText]="false"
        [json_data]="true"
        [unit]="true">
      </app-dropdown-checkbox-selection>
    </ng-container>
  </div>
</div>

<ng-container *ngIf="priceChartData?.length && !chartLoader">
  <app-comparable-chart [chartData]="priceChartData" [chartId]="chartId" [laguagecode]="currentLang">
  </app-comparable-chart>
</ng-container>

<div class="no-chart-data" *ngIf="!priceChartData?.length && !chartLoader">
  <strong>{{'no_data_chart_message1' | translate}}</strong>
  <div class="message">
      <p>{{'no_data_chart_message2' | translate}}</p>
      <p>{{'no_data_chart_message3' | translate}}</p>
  </div>
</div>
<div class="comparable" *ngIf="priceChartData?.length && isAllComparableNull(priceChartData) && !chartLoader">
      <p>{{'reports.noDataComparableProperty' | translate}}</p>
</div>
<div *ngIf="chartLoader">
  <app-skeleton-loader [reportType]="chartView.lineChart" [height]="'15px'" [width]="'90%'"></app-skeleton-loader>
</div>
